import { createFileRoute } from "@tanstack/react-router";
import CrisisResourcesPage from "@/pages/CrisisResourcesPage";
export const Route = createFileRoute("/crisis-resources")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Crisis Resources | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "If you’re in crisis, call or text 988. Find local and national mental health crisis resources, hotlines, and support from Neuro Wellness TMS in Coral.",
        },
        {
          property: "og:title",
          content: "Crisis Resources | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "If you’re in crisis, call or text 988. Find local and national mental health crisis resources, hotlines, and support from Neuro Wellness TMS in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/crisis-resources",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/crisis-resources",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CrisisResourcesPage />;
}
